<template>
  <div class="attributes container">
    <div class="stats">
      <StatisticIcon
        v-for="stat in order"
        :key="stat"
        :name="stat"
        :value="stat"
        :icon="stat"
        :icon-text="iconText(stat)"
        :label="label(stat)"
      ></StatisticIcon>
    </div>
    <div class="stats">
      <StatisticIcon
        name="Init"
        icon="game-icons:empty-hourglass"
        :value="stats.initiative || 'dex'"
        label="Initiative"
        force-modifier
      />
      <StatisticIcon name="AC" icon="game-icons:bordered-shield" :value="stats.ac" constant unit=" " />
      <StatisticIcon
        v-for="speed in speeds"
        :key="speed.name"
        :name="speed.name"
        :icon="speed.icon"
        :value="speed.value || 0"
        constant
        unit="ft"
        :title="speed.label"
      />
      <StatisticIcon
        :name="senses.name"
        :icon="senses.icon"
        :value="senses.value"
        unit="ft"
        constant
        :title="senses.label"
      />
      <StatisticIcon name="Prof" icon="fa6-regular:star" value="prof" constant />
      <StatisticIconCounter v-model="exhaustion" name="Exh" :maximum="6" />
      <StatisticIconToggle
        name="Insp"
        icon="fa6-solid:lightbulb"
        icon-off="fa6-regular:lightbulb"
        :reset-value="stats.race === 'human' || stats.race === 'half-elf' ? 1 : 0"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type CharacterSheetData, type Ability, resolveSenses, resolveSpeed } from '../statblock/statblock'
import StatisticIcon from './StatisticIcon.vue'
import StatisticIconToggle from './StatisticIconToggle.vue'
import StatisticIconCounter from './StatisticIconCounter.vue'
import { resolveDice } from '~/assets/dice/diceEval'

const props = defineProps<{
  stats: CharacterSheetData
}>()

const exhaustion = useResource(ref('exhaustion'))

const order: Ability[] = ['str', 'dex', 'con', 'int', 'wis', 'cha']

const speeds = computed(() => resolveSpeed(props.stats.speed, exhaustion.value))

const senses = computed(() => resolveSenses(props.stats.senses))

const label = (stat: string) => {
  const longName = {
    str: 'Strength',
    dex: 'Dexterity',
    con: 'Constitution',
    int: 'Intelligence',
    wis: 'Wisdom',
    cha: 'Charisma',
  }[stat]
  return `${longName} check`
}

const iconText = (stat: Ability) => resolveDice(props.stats.abilities[stat], {}, true)
</script>

<style scoped lang="postcss">
.attributes {
  grid-area: attributes;
  display: flex;
  gap: 0 1em;

  @media (max-width: 1399px) {
    flex-wrap: wrap;
  }

  .stats {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
